<template>
  <div class="row">
    <div class="col-6 row">
      <div class="col-3 mb-2">
        {{ $t('autocaller_v2.campaign.field.type') }}
      </div>
      <i-select
        class="col-12"
        v-model="sort.value"
        :clearable="true"
        :disabled="!options.length"
        @input="input($event)"
      >
        <i-option
          v-for="item in options"
          :value="item.value"
          :label="item.label"
          :key="item.value"
          ref="l"
        />
      </i-select>
    </div>
    <div class="col-6 row">
      <div class="col-3 mb-2">
        {{ $t('autocaller_v2.campaign.field.direction') }}
      </div>
      <i-select
        class="col-12"
        v-model="order.value"
        :clearable="true"
        :disabled="!options.length"
        @input="input"
      >
        <i-option value="asc" :label="$t('autocaller_v2.campaign.sort.order.asc')" />
        <i-option value="desc" :label="$t('autocaller_v2.campaign.sort.order.desc')" />
      </i-select>
    </div>
    <div class="col row">
      <icon
        v-if="enabled && options.length"
        size="20"
        class="d-flex flex-column-reverse mb-2"
        type="md-add-circle"
        @click="addItem"
      />
      <tooltip
        class="d-flex flex-column-reverse mb-2 ml-4"
        placement="top"
        min-width="400"
        max-width="400"
        theme="light"
        :content="$t('autocaller_v2.campaign.tooltips.sort')"
      >
        <icon size="18" type="ios-help-circle-outline" />
      </tooltip>
    </div>

    <draggable
      v-model="items"
      class="list-group col-12"
      ghost-class="ghost"
      :move="checkMove"
      @start="dragging = true"
      @end="dragging = false"
    >
      <div class="list-group-item col-12 d-flex" v-for="item in filter_items" :key="item.value">
        <icon
          v-if="item.order == 'desc'"
          type="md-arrow-round-down"
          @click="changeOrder($event)"
          class="mt-1"
          size="16"
          :data-value="item.field"
        />
        <icon
          v-else
          type="md-arrow-round-up"
          @click="changeOrder($event)"
          class="mt-1"
          size="16"
          :data-value="item.field"
        />
        <span class="col-11">{{ $t(`autocaller_v2.campaign.sort.type.${item.field}`) }}</span>
        <icon
          type="md-close-circle"
          @click="remove($event)"
          class="col-offset-4 mt-1"
          size="16"
          :data-value="item.field"
        />
      </div>
    </draggable>
  </div>
</template>

<script>
  import Draggable from '@app/plugins/vuedraggable';
  export default {
    props: {
      order_rules: {
        type: Array,
        default: () => []
      }
    },
    components: {
      Draggable
    },
    data() {
      return {
        sort: {
          value: '',
          options: [
            {
              value: 'priority',
              label: this.$t('autocaller_v2.campaign.sort.type.priority')
            },
            {
              value: 'lead_date',
              label: this.$t('autocaller_v2.campaign.sort.type.lead_date')
            },
            {
              value: 'attempts',
              label: this.$t('autocaller_v2.campaign.sort.type.attempts')
            }
          ]
        },
        order: {
          value: ''
        },
        items: this.order_rules,
        dragging: false
      };
    },
    computed: {
      enabled() {
        return this.sort.value && this.order.value ? true : false;
      },
      filter_items() {
        return this.order_rules.length ? this.order_rules : this.items;
      },
      options() {
        if (this.order_rules.length) {
          let item = this.order_rules.map((item) => item);
          let options = this.sort.options.filter((o) => item.every((i) => o.value !== i.field));
          return options;
        }
        return this.items.length
          ? this.sort.options.filter((o) => this.items.every((i) => o.value !== i.field))
          : this.sort.options;
      }
    },
    watch: {
      items: {
        handler(e) {
          this.$emit('sort', e);
        }
      }
    },
    methods: {
      remove(e) {
        this.items = this.items.filter((i) => i.field != e.target.dataset.value);
      },
      changeOrder(e) {
        this.items = this.items.map(function (item) {
          if (item.field == e.target.dataset.value) {
            item.order == 'asc' ? (item.order = 'desc') : (item.order = 'asc');
          }
          return item;
        });
      },
      checkMove() {
        console.log('move');
      },
      addItem() {
        this.items.push({ field: this.sort.value, order: this.order.value });
        this.sort.value = this.order.value = '';
      },
      input(event) {
        this.$emit('input', event);
      }
    }
  };
</script>

<style scoped>
  .ivu-icon {
    cursor: pointer;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    margin-top: 20px;
  }
  .list-group-item {
    display: flex;
    cursor: move;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
  }
  .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
</style>
